import { render, staticRenderFns } from "./failureSourceStats.vue?vue&type=template&id=5376a4cf&"
import script from "./failureSourceStats.vue?vue&type=script&lang=js&"
export * from "./failureSourceStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports